export enum PersonalRoutes {
  root = 'personal',
  settings = 'settings',
  profile = 'profile',
  security = 'security',
  voicemailDrop = 'voicemail-drop',
  authorizedApps = 'authorized-apps',
}
